(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-winter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();
})();
